import {EntityKey} from '../entity/entity'

export class FpaScenario {

  entityKey!: EntityKey;
  saleType!: string;
  multiplier!: number;
  totalList!: number;
  shippingCharge!: number;
  specialCharges!: number;
  commissionPercent!: number;
  overrideCommissionPercent!: number;
  requestedMultiplier!: string;
  poAmount!: string;
  approvalStatus!: string;
  customScenarioId!: number;
  target!: boolean;

}
